// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"b7682a5a","352":"9fc7cbc4","460":"bf310b7e","948":"3f087a92"}[chunkId] + ".chunk.js";
};